import React, { useEffect, useState } from "react";
import Button from "sushiweb/Button";
import FeatureToggleFormModal from "../../components/FeatureToggle/FeatureToggleFormModal";
import FeatureToggleList from "../../components/FeatureToggle/FeatureToggleList";
import ListPagination from "../../components/Common/ListPagination";
import { filterObj, isMobile, parseString } from "../../utils";
import styled from "styled-components";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FeatureToggleActions from "../../store/actions/FeatureToggle";
import * as CountryActions from "../../store/actions/Country";
import * as CityActions from "../../store/actions/City";
import * as UserActions from "../../store/actions/User";
import Permission from "../../components/Common/Permission";
import Errors from "../../constants/Errors.json";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import FilterButton from "../../components/Common/FilterButton";

const FeatureToggle = (props) => {
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.FEATURE_TOGGLE];
  const { getCityList, setStatus, createFeatureToggle, checkFeatureToggleEnabled } = props;

  const filterFields = [
    "entityType",
    "entityValue",
    "enabled",
    "featureName",
    "featureScope",
    "setConditions",
    "entitySubType",
  ];

  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  //update enable/disable state
  const handleToggleUpdate = (item, isEnabled) => {
    const nextAction = isEnabled ? false : true;
    const payload = {
      ...item,
      enabled: nextAction,
    };
    const body = filterObj(payload, [
      "featureName",
      "featureScope",
      "enabled",
      "entityValue",
      "entityType",
      "entitySubType",
      "serviceId",
      "conditions",
    ]);
    body.conditions = parseString(body?.conditions);
    createFeatureToggle("/feature/toggle/upsert", body).then((res) => {
      if (res) {
        let pageRequest = {
          page: currentPage,
        };
        props.getFeatureToggleList(props.activeFiltersToggle, pageRequest);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  const getToggleEnabled = (item, isEnabled) => {
    const nextAction = isEnabled ? false : true;
    const payload = {
      ...item,
      enabled: nextAction,
    };
    const body = filterObj(payload, [
      "featureName",
      "featureScope",
      "enabled",
      "entityValue",
      "entityType",
      "entitySubType",
      "serviceId",
      "conditions",
    ]);
    body.conditions = parseString(body?.conditions);
    checkFeatureToggleEnabled("/feature/toggle/enabled", body).then((res) => {
      if (res) {
        let pageRequest = {
          page: currentPage,
        };
        props.getFeatureToggleList(props.activeFiltersToggle, pageRequest);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      props.getFeatureToggleList(props.activeFiltersToggle, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      props.getFeatureToggleList(props.activeFiltersToggle, pageRequest);
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "Add":
      case "Edit":
        return (
          <FeatureToggleFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      case "Filter":
        return (
          <FeatureToggleFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
            filterFields={filterFields}
          />
        );
      case "Check":
        return (
          <FeatureToggleFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
            filterFields={filterFields}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    props.getFeatureToggleList();
    props.resetStateCountry({ state: "countryList" });
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFiltersToggle)]);

  return (
    <FeatureToggleViewContainer className="Feature-Toggle-View container">
      <FlexContainer align="flex-start">
        <Heading>Feature Toggle Dashboard</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <Button
              onClick={() => handleClick("Check", null)}
              className="sushi-btn mr-20"
              data-testid="featureToggleCreatebtn"
              appearance="outline"
            >
              Check Toggle
            </Button>
          </Permission>
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFiltersToggle}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="featureToggleCreatebtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <FeatureToggleList
        handleToggleUpdate={handleToggleUpdate}
        featureToggleList={props.featureToggleList}
        handleClick={handleClick}
      />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && getModal()}
    </FeatureToggleViewContainer>
  );
};

const FeatureToggleViewContainer = styled.div`
  & > div {
    flex-direction: ${isMobile() ? "column" : "row"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
  }
`;

function mapStateToProps(state) {
  const { FeatureToggle } = state;
  return {
    featureToggleList: FeatureToggle.featureToggleList,
    nextPage: FeatureToggle.nextPage,
    prevPage: FeatureToggle.prevPage,
    activeFiltersToggle: FeatureToggle.activeFiltersToggle,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFeatureToggleList: bindActionCreators(
      FeatureToggleActions.getFeatureToggleList,
      dispatch
    ),
    resetStateCountry: bindActionCreators(CountryActions.resetState, dispatch),
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    createFeatureToggle: bindActionCreators(
      FeatureToggleActions.createFeatureToggle,
      dispatch
    ),
    checkFeatureToggleEnabled: bindActionCreators(
      FeatureToggleActions.checkFeatureToggleEnabled,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FeatureToggle);
